import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { URL_FINANZAS, auth, fmt } from "./finanzasUtils";

const URL_GASTOS = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;

// Todo el dinero de un contenedor: lo que paga el cliente y lo que se paga al broker
export default function DetalleContenedor({ contenedor, cerrar, user, accion, refresco, onCambio }) {
  const [datos, setDatos] = useState(null);

  const carga = () => {
    axios
      .get(`${URL_FINANZAS}Contenedor/${contenedor._id}`, auth())
      .then(({ data }) => setDatos(data))
      .catch((err) => Swal.fire({ icon: "error", title: "No se pudo cargar", text: err?.response?.data?.message || err.message }));
  };
  useEffect(() => {
    setDatos(null);
    if (contenedor) carga();
  }, [contenedor, refresco]); // eslint-disable-line

  const autorizar = async (id) => {
    try {
      await axios.patch(`${URL_GASTOS}/${id}`, { autorizado: "Si" }, auth());
      carga();
      onCambio();
    } catch (err) {
      Swal.fire({ icon: "error", title: "No se pudo autorizar", text: err?.response?.data?.message || err.message });
    }
  };

  return (
    <Modal size="xl" isOpen={!!contenedor} toggle={cerrar}>
      <ModalHeader toggle={cerrar}>
        <span>Contenedor {contenedor ? contenedor.referencia : ""} · {contenedor ? contenedor.cliente : ""}</span>
      </ModalHeader>
      <ModalBody>
        <div className="fz-acciones">
          {user.menuAdmin ? <Button size="sm" color="info" onClick={() => accion("cargos", contenedor)}><i className="fas fa-plus" /> Cargo</Button> : null}
          {user.abonosCreate ? <Button size="sm" color="success" onClick={() => accion("abonos", contenedor)}><i className="fas fa-hand-holding-usd" /> Abono</Button> : null}
          {user.gastosCreate ? <Button size="sm" color="primary" onClick={() => accion("gastos", contenedor)}><i className="fas fa-plus" /> Gasto</Button> : null}
          {user.pagosCreate ? <Button size="sm" color="warning" onClick={() => accion("pagos", contenedor)}><i className="fas fa-money-check-alt" /> Pago</Button> : null}
        </div>

        {!datos ? (
          <div className="rc-state"><i className="fas fa-spinner fa-spin" /><div>Cargando…</div></div>
        ) : (
          <>
            <h5 className="fz-titulo">Cliente: cargos y abonos</h5>
            {datos.cobro.length === 0 ? (
              <div className="td-muted mb-3">Sin cargos ni abonos.</div>
            ) : (
              <Table size="sm" hover>
                <thead>
                  <tr>
                    <th>Fecha</th><th>Movimiento</th><th>Folio</th><th>Detalle</th>
                    <th className="td-num">Cargo</th><th className="td-num">Abono</th><th className="td-num">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  {datos.cobro.map((m, i) => (
                    <tr key={i}>
                      <td>{m.fecha}</td>
                      <td>{m.tipo}{m.comprobante === "Si" ? <i className="fas fa-receipt fz-comprobante" title="Con comprobante" /> : null}</td>
                      <td>{m.folio}</td>
                      <td>{m.detalle}</td>
                      <td className="td-num td-money">{m.cargo ? fmt(m.cargo) : "—"}</td>
                      <td className="td-num td-money">{m.abono ? fmt(m.abono) : "—"}</td>
                      <td className="td-num td-money">{fmt(m.saldo)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            <h5 className="fz-titulo">Brokers: gastos y pagos</h5>
            {datos.costo.length === 0 ? (
              <div className="td-muted">Sin gastos ni pagos.</div>
            ) : (
              <Table size="sm" hover>
                <thead>
                  <tr>
                    <th>Fecha</th><th>Movimiento</th><th>Folio</th><th>Broker</th><th>Detalle</th>
                    <th className="td-num">Gasto</th><th className="td-num">Pago</th><th className="td-num">Saldo</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {datos.costo.map((m, i) => (
                    <tr key={i}>
                      <td>{m.fecha}</td>
                      <td>{m.tipo}</td>
                      <td>{m.folio}</td>
                      <td>{m.broker}</td>
                      <td>{m.detalle}</td>
                      <td className="td-num td-money">{m.gasto ? fmt(m.gasto) : "—"}</td>
                      <td className="td-num td-money">{m.pago ? fmt(m.pago) : "—"}</td>
                      <td className="td-num td-money">{fmt(m.saldo)}</td>
                      <td>
                        {m.tipo !== "Gasto" ? null : m.autorizado === "Si" ? (
                          <span className="badge-soft badge-soft-success">Autorizado</span>
                        ) : user.gastosAutorizar ? (
                          <Button size="sm" color="success" onClick={() => autorizar(m._id)}>Autorizar</Button>
                        ) : (
                          <span className="badge-soft badge-soft-warning">Sin autorizar</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
}
